// export const base = '';
export const base = '/DataExplorer';